import { render, staticRenderFns } from "./PaNextOfKinForm.vue?vue&type=template&id=118871c3&scoped=true"
import script from "./PaNextOfKinForm.vue?vue&type=script&lang=js"
export * from "./PaNextOfKinForm.vue?vue&type=script&lang=js"
import style0 from "./PaNextOfKinForm.vue?vue&type=style&index=0&id=118871c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118871c3",
  null
  
)

export default component.exports